import { Platform } from 'react-native';

import ENV from 'react-native-config';
import { MMKV } from 'react-native-mmkv';

export enum StorageKeys {
    LANDING_PAGE_SHOWN = 'LANDING_PAGE_SHOWN',
    DEEPLINK_RETURN_TO_LAUNCHER = 'DEEPLINK_RETURN_TO_LAUNCHER', // Value is '1' or null
    DEEPLINK_THIRD_PART_APP_NAME = 'DEEPLINK_THIRD_PART_APP_NAME', // Value is the 'appName' of 3-rd party app or null
    PERSONALIZE_PAGE_SHOWN = 'PERSONALIZE_PAGE_SHOWN',
    TUTORIAL_PAGE_SHOWN = 'TUTORIAL_PAGE_SHOWN',
    FTI_PROFILES_SHOWN = 'FTI_PROFILES_SHOWN',
    CASHED_PIN_TIMESTAMP = 'CASHED_PIN_TIMESTAMP',
    TEMPLATEVIEW = 'TEMPLATEVIEW',
}

// Redux-persist storage adapter for MMKV
class MMKVStorageAdapter {
    private storage: MMKV;

    constructor(storage: MMKV) {
        this.storage = storage;
    }

    // Required methods for redux-persist
    setItem = (key: string, value: string): Promise<void> => {
        try {
            this.storage.set(key, value);

            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getItem = (key: string): Promise<string | null> => {
        try {
            const value = this.storage.getString(key);

            return Promise.resolve(value || null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    removeItem = (key: string): Promise<void> => {
        try {
            this.storage.delete(key);

            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
}

// Export pre-configured storage adapters for redux-persist
export const RegularStorage = new MMKVStorageAdapter(
    new MMKV({
        id: 'onetv.regular.storage',
    }),
);

// Encryption is not supported in Web, so we will use RegularStorage everywhere in Web.
export const SecureStorage = Platform.select({
    web: RegularStorage,
    default: new MMKVStorageAdapter(
        new MMKV({
            id: 'onetv.secure.storage',
            ...Platform.select({
                web: {},
                default: {
                    encryptionKey: ENV.SECURE_STORAGE_ENCRYPTION_KEY,
                },
            }),
        }),
    ),
});
